export default __webpack_public_path__ + "static/media/KillerVespa.decabf10.jpg";